<template>
    <div class="supplier-basic-info">
        <div v-loading="overallLoading">
            <div style="border-bottom:1px solid #E4E7ED;float: right;">
                <el-button style="margin-top: 7px;" type="success" v-if="this.applyStatus === '提交企业信息' || this.applyStatus === '重新提交信息'"
                        size="mini"  @click="submit()" :loading="submitLoading">提交评审
                </el-button>
                <el-button style="margin-top: 7px;" type="success" v-if="this.applyStatus === '完善供应商信息'"
                          size="mini" @click="submit2()" :loading="submit2Loading">提交完善评审
                </el-button>
                <el-button style="margin-top: 7px;" size="mini" v-if="this.applyStatus === '采购工程师审批'" type="success" @click="submit3()">撤回</el-button>
            </div>

            <el-tooltip class="item" effect="light" content="请仔细阅读填写说明" placement="top-end">
                <el-link type="primary" @click="drawer = true" style="float: right;line-height: 40px;padding-right: 8px;border-bottom:1px solid #E4E7ED;">?填写说明</el-link>
            </el-tooltip>
            <el-tabs class="supplier-info-tabs" v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="企业概况" name="企业概况">
                    <span slot="label"><span style="color: red">*</span>企业概况</span>
                    <enterprise-profile ref="enterpriseProfile" @getId="getId" :applyStatus="applyStatus"></enterprise-profile>
                </el-tab-pane>
                <el-tab-pane label="主要联系人员" name="主要联系人员">
                    <span slot="label"><span style="color: red">*</span>主要联系人员</span>
                    <main-contacts ref="mainContacts" :applyStatus="applyStatus"></main-contacts>
                </el-tab-pane>
                <el-tab-pane label="企业资源情况" name="企业资源情况">
                    <span slot="label"><span style="color: red">*</span>企业资源情况</span>
                    <resource-info ref="resourceInfo" :applyStatus="applyStatus"></resource-info>
                </el-tab-pane>
                <el-tab-pane label="工厂及地址" name="工厂及地址">
                    <span slot="label"><span style="color: red">*</span>工厂及地址</span>
                    <factory-info ref="factoryInfo" :applyStatus="applyStatus"></factory-info>
                </el-tab-pane>
                <el-tab-pane label="企业经营状况" name="企业经营状况">
                    <span slot="label"><span style="color: red">*</span>企业经营状况</span>
                    <business-info ref="businessInfo" :applyStatus="applyStatus"></business-info>
                </el-tab-pane>
                <el-tab-pane label="主要产品目录" name="主要产品目录">
                    <span slot="label"><span style="color: red">*</span>主要产品目录</span>
                    <product-info ref="productInfo" :applyStatus="applyStatus"></product-info>
                </el-tab-pane>
                <el-tab-pane name="附件上传">
                    <span slot="label"><span style="color: red">*</span>附件上传</span>
                    <attachment-upload ref="attachmentUpload" :applyStatus="applyStatus"></attachment-upload>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-drawer :visible.sync="drawer" dock="right" title="注册填写说明">
            <code>
                <register-tips refs="registerTips"></register-tips>
            </code>
        </el-drawer>
    </div>
</template>

<script>
    import { submitRegisterApplyForm,submitRegisterApplyForm2,getBasicInfoFiles,recallPrefixNode,getWorkflowIdByInviteFid} from '@/controller/portal'
    import { fetchTodoList } from '@/controller/workflow'
    import EnterpriseProfile from './enterpriseProfile'
    import MainContacts from './mainContacts'
    import ResourceInfo from './resourceInfo'
    import FactoryInfo from './factoryInfo'
    import BusinessInfo from './businessInfo'
    import ProductInfo from './productInfo'
    import AttachmentUpload from './attachmentUpload'
    import RegisterTips from "./registerTips";

    export default {
        components: {
            RegisterTips,
            EnterpriseProfile,
            ResourceInfo,
            MainContacts,
            FactoryInfo,
            BusinessInfo,
            ProductInfo,
            AttachmentUpload
        },
        data() {
            return {
                overallLoading:false,
                submitLoading:false,
                submit2Loading:false,
                addOrUpdateVisible: false,
                applyStatus: '',//申请状态
                createdBy: '',
                styleName: '企业概况',
                id: '',
                activeName: '企业概况',
                venderInviteFid: '',
                basicInfoId: '',
                totalPage: 0,
                pageIndex: 1,
                pageSize: 10,
                drawer: false,
                workflowId: '',
                taskIds: []
            }
        },
        watch: {
            applyStatus() {
                this.getStatus()
                console.log(this.applyStatus)
            },
            venderInviteFid() {
                this.getStatus()
                this.init()
            }
        },
        method() {
            this.init()
        },
        methods: {
            init() {
            },
            getId(data1, data2, data3, data4, workflowId) {
                this.id = data1
                this.venderInviteFid = data2
                this.basicInfoId = data3
                this.createdBy = data4
                this.workflowId = workflowId
                if (this.basicInfoId) {
                    this.drawer = false
                } else {
                    this.drawer = true
                }
            },
            handleClick: function () {
                if (this.activeName == '企业经营状况') {
                    this.$refs.businessInfo.getDataList(this.basicInfoId, this.applyStatus)
                }
                if (this.activeName == '企业资源情况') {
                    this.$refs.resourceInfo.getDataList(this.basicInfoId, this.applyStatus)
                }
                if (this.activeName == '工厂及地址') {
                    this.$refs.factoryInfo.getDataList(this.basicInfoId, this.applyStatus)
                }
            },
            //供应商提交申请----潜在
            submit() {
                this.overallLoading = true
                // 提交前必须有供应商信息
                if (this.basicInfoId == '') {
                    this.$message.error("请先填写并保存企业基本信息。")
                    this.overallLoading = false
                    return
                }

                // chek附件 营业执照、体系认证、公司简介、主要设备清单、 为必传
                getBasicInfoFiles({
                    'inviteId' : this.venderInviteFid
                }).then(data => {
                    if (data && data.code === '00') {
                        var msg = "营业执照、体系认证、公司简介、主要设备清单、";
                        for(var i=0;i<data.body.length;i++){
                            msg = msg.replace(data.body[i].bizSubTypeName + "、","");
                        }

                        if(msg != ""){
                            this.overallLoading = false
                            this.$message.error("请在[附件上传]处，先上传【"+ msg +"】，才可提交评审。")
                            return
                        }else{

                            submitRegisterApplyForm({
                                'inviteId': this.venderInviteFid,
                                'buyerId': this.createdBy,
                                'workflowId': this.workflowId,
                                'taskIds': this.taskIds
                            }).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '提交成功',
                                        type: 'success',
                                        duration: 1500,
                                        onClose: () => {
                                            this.getStatus()
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            }).catch(() =>{

                            }).finally(() => {
                                this.overallLoading = false
                            })
                        
                        }

                    }

                })
            },
            
            // 供应商提交申请 ---- 合格邀请
            submit2(){
                // 提交前必须有供应商信息
                if (this.basicInfoId == '') {
                    this.$message.error("请先填写并保存企业基本信息。")
                    return
                }
                // chek附件 营业执照、体系认证、公司简介、主要设备清单、 为必传
                getBasicInfoFiles({
                    'inviteId' : this.venderInviteFid
                }).then(data => {
                    if (data && data.code === '00') {
                        var msg = "营业执照、体系认证、公司简介、主要设备清单、";
                        for(var i=0;i<data.body.length;i++){
                            msg = msg.replace(data.body[i].bizSubTypeName + "、","");
                        }
                        if(msg != ""){
                            this.$message.error("请在[附件上传]处，先上传【"+ msg +"】，才可提交评审。")
                            return
                        }else{
                            submitRegisterApplyForm2({
                                'inviteId': this.venderInviteFid,
                                'buyerId': this.createdBy,
                                'workflowId': this.workflowId,
                                'taskIds': this.taskIds
                            }).then(data => {
                                if (data && data.code === '00') {
                                    this.$message({
                                        message: '提交成功',
                                        type: 'success',
                                        duration: 1500,
                                        onClose: () => {
                                            this.getStatus()
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })
                        
                        }

                    }

                })
            },

            //获取当前按钮状态
            getStatus() {
                fetchTodoList({
                }).then(data => {
                    if (data.body.records.length != 0) {
                        this.applyStatus = data.body.records[0].taskName
                        this.taskIds = data.body.records.map(item => {
                            return item.taskId
                        })
                    } else {
                        getWorkflowIdByInviteFid({'inviteFid': this.venderInviteFid}).then(data => {
                            if (data && data.code === '00') {
                                if(data.body){
                                    this.applyStatus = data.body.applyStatus
                                    console.log(this.applyStatus,'审批状态')
                                }
                            }else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                })
            },
            // 撤回
            submit3(){ 
                getWorkflowIdByInviteFid({'inviteFid': this.venderInviteFid}).then(data => {
                    if (data && data.code === '00') {
                        if(data.body){
                            recallPrefixNode(
                                { workflowId:data.body.workFlowId}
                            ).then(data => {
                                if (data && data.code === '00') {
                                    this.applyStatus = data.body.applyStatus
                                    this.$message({
                                        message: '退回成功',
                                        type: 'success',
                                        duration: 1500,
                                        onClose: () => {
                                            this.getStatus()
                                        }
                                    })
                                } else {
                                    this.$message.error(data.msg)
                                }
                            })

                        }
                    }else {
                        this.$message.error(data.msg)
                    }
                })
            }
        }
    }
</script>
<style lang="scss">
    .supplier-basic-info {
        .supplier-info-tabs > .el-tabs__header {
            margin-bottom: 0;
            overflow: hidden;
        }

        .supplier-info-tabs > .el-tabs__content {
            overflow: visible;
        }

        .el-drawer__header {
            margin-bottom: 0 !important;
        }
    }
</style>
